module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"helix":"Helix Collection","start":"START THE {br} CONFIGURATION"},"fr":{"helix":"Collection Helix","start":"DÉMARRER LA {br} CONFIGURATION"},"pl":{"helix":"Kolekcja Helix","start":"START {br} KONFIGURACJI"},"de":{"helix":"Helix Kollektion","start":"KONFIGURATION {br} STARTEN"}}')
  delete Component.options._Ctor
}
